module.exports = __webpack_public_path__ + "img/flow2.b0d0349b.png";